/**
 * Product compare toggle (stores selected product handles in sessionStorage)
 */
(function () {
  const page = document.querySelector('.collection-page');
  const toggle = document.querySelector('[data-compare-toggle]');
  if (!page || !toggle) return;

  document.querySelectorAll('.product-card').forEach((card) => {
    const link = card.querySelector('.product-card__title a');
    if (!link) return;
    const handle = link.getAttribute('href')?.split('/products/')[1]?.split('?')[0];
    if (!handle) return;

    const cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.className = 'product-card__compare';
    cb.dataset.compareProduct = handle;
    cb.setAttribute('aria-label', 'Compare ' + link.textContent.trim());
    cb.addEventListener('change', updateCompare);
    card.querySelector('.product-card__media')?.appendChild(cb);
  });

  function updateCompare() {
    const selected = [...document.querySelectorAll('[data-compare-product]:checked')].map((el) => el.dataset.compareProduct);
    sessionStorage.setItem('alverio-compare', JSON.stringify(selected));
    toggle.checked = selected.length > 0;
    page.classList.toggle('is-compare-mode', toggle.checked || selected.length > 0);
  }

  toggle.addEventListener('change', () => {
    page.classList.toggle('is-compare-mode', toggle.checked);
    if (!toggle.checked) {
      document.querySelectorAll('[data-compare-product]:checked').forEach((el) => {
        el.checked = false;
      });
      sessionStorage.removeItem('alverio-compare');
    }
  });

  const saved = sessionStorage.getItem('alverio-compare');
  if (saved) {
    try {
      const handles = JSON.parse(saved);
      handles.forEach((handle) => {
        const cb = document.querySelector('[data-compare-product="' + handle + '"]');
        if (cb) cb.checked = true;
      });
      if (handles.length) {
        toggle.checked = true;
        page.classList.add('is-compare-mode');
      }
    } catch (e) {
      sessionStorage.removeItem('alverio-compare');
    }
  }
})();
